export default {
  microserviceBaseUrl: import.meta.env.VITE_SANITAS_MICROSERVICE_URI,
  resourceBaseUrl: import.meta.env.VITE_SANITAS_RESOURCE_URI,
  masterdataBaseUrl: import.meta.env.VITE_SANITAS_MASTERDATA_URI,
  apiPath: import.meta.env.VITE_API_PATH,
}
